var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"counter-box"}},[_c('p',{attrs:{"id":"counter"}},[_vm._v(_vm._s(_vm.sumDevices))]),_c('v-icon',{attrs:{"id":"icono"}},[_vm._v(" mdi-cart ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }